// Shared "Jetzt aktualisieren" → spawn motor → poll om_jobs helper for the
// data-driven marketing tabs (Blog-Radar §2, Analytics §3, Opportunities §5).
// Mirrors the SEO-Audit flow in marketing.ts: POST a run endpoint, then poll
// /api/marketing/jobs?type=… every 5 s until the motor's job row is done/failed.
import type { MarketingDeps } from "./marketing.js";

interface Job {
  id: number; type: string; status: string;
  started_at: string; finished_at: string | null; log: string | null;
}
interface JobsResponse { jobs: Job[] }

export interface MotorRunOpts {
  deps: MarketingDeps;
  modal: HTMLElement;          // polling stops once the modal is detached
  btn: HTMLElement | null;     // "Jetzt aktualisieren" trigger
  msg: HTMLElement | null;     // inline status line
  jobType: string;             // om_jobs.type the motor writes
  runUrl: string;              // POST endpoint that spawns the motor
  onDone: () => Promise<void>; // reload the view after a successful run
}

export function wireMotorRun(opts: MotorRunOpts): void {
  const { deps, modal, btn, msg, jobType, runUrl, onDone } = opts;
  if (!btn) return;
  let pollTimer: number | undefined;
  const setMsg = (t: string): void => { if (msg) msg.textContent = t; };

  const poll = async (): Promise<void> => {
    const jr = await deps.api<JobsResponse>(`/api/marketing/jobs?type=${encodeURIComponent(jobType)}`);
    const running = jr.data?.jobs.some((j) => j.status === "running");
    const finished = jr.data?.jobs.find((j) => j.status !== "running");
    if (!running && finished) {
      setMsg(finished.status === "done"
        ? `Fertig: ${deps.formatDate(finished.finished_at ?? finished.started_at)}`
        : `Fehlgeschlagen: ${finished.log ?? ""}`);
      await onDone();
      return;
    }
    if (modal.isConnected) pollTimer = window.setTimeout(() => { void poll(); }, 5000);
  };

  btn.addEventListener("click", () => {
    void (async () => {
      setMsg("Starte …");
      const r = await deps.api<{ stamp?: string }>(runUrl, "POST");
      if (r.status === 409) { setMsg("Läuft bereits."); return; }
      if (r.status !== 200) { setMsg(`Fehler (${r.status})`); return; }
      setMsg(`Läuft (${r.data?.stamp}) — Ergebnis erscheint hier automatisch.`);
      pollTimer = window.setTimeout(() => { void poll(); }, 5000);
    })();
  });

  modal.addEventListener("click", (e) => {
    if ((e.target as HTMLElement).classList.contains("modal-backdrop")) window.clearTimeout(pollTimer);
  });
}
